import { useNavigate, useLocation } from 'react-router-dom';

export enum SceneRoutes {
  UploadScene = '/upload',
  LoginScene = '/login',
  ThankYouScene = '/thank-you',
}

const useSceneNavigator = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const history = {
    goBack: () => navigate(-1),
    goForward: () => navigate(1),
    location,
    push: (path: string | SceneRoutes) => {
      navigate(path);
    },
    replace: (path: string | SceneRoutes) => {
      navigate(path, {
        replace: true,
      });
    },
  };

  const navigateToScene = (path: SceneRoutes) => {
    history.push(path);
  };

  return {
    history,
    navigate: navigateToScene,
  };
};

export default useSceneNavigator;
